import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Spinner,
  Alert,
} from "reactstrap";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import {
  userForgetPassword,
  resetForgetPassword,
} from "../../store/auth/forgetpwd/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/brands/logo-sm-light.png";
import darkLogo from "../../assets/images/logo-sm-dark.png";
//i18n
import { withTranslation } from "react-i18next";
import { recoveryLimitExceeded, renderMessageAlert } from "./helpers";

const ForgetPasswordPage = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { mainTheme } = useSelector((state) => state.Layout);
  const { error, success, loading, message } = useSelector(
    (state) => state.ForgetPassword
  );
  const { saveDateStorage, getDateStorage } = recoveryLimitExceeded();

  const [counter, setCounter] = useState("60:00");
  const [firstAction, setFirstAction] = useState(true);

  const currentTime = getDateStorage();

  const showAlert = error || (currentTime && !currentTime?.includes("00:00"));

  const textAlert =
    error?.[0]?.value ?? error ?? "Maximum number of attempts reached";

  const isDisabled = firstAction || counter?.includes("00:00");

  const handleValidSubmit = (event, values) => {
    dispatch(userForgetPassword(values, history));
  };

  useEffect(() => {
    dispatch(resetForgetPassword());
  }, [dispatch]);

  const startTimer = (min) => {
    setFirstAction(false);

    let temp = min ? min * 60 : 3600;

    let timer = setInterval(() => {
      if (temp - 1 >= -1) {
        var min = parseInt(temp / 60);
        var seg = temp % 60;

        if (min < 10) {
          min = "0" + min;
          min = min.substr(0, 2);
        }

        if (seg <= 9) {
          seg = "0" + seg;
        }

        setCounter(`${min}:${seg}`);
        saveDateStorage(`${min}:${seg}`);

        temp--;
      }
    }, 1000);

    return timer;
  };

  useEffect(() => {
    let timer = null;
    if (!error && currentTime && !currentTime?.includes("00:00")) {
      const [min] = currentTime?.split(":");
      timer = startTimer(min);
    }

    if (error?.[0]?.value === "Maximum number of attempts reached") {
      timer = startTimer();
    }

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {t("Password recovery")}
                        </h5>
                        <p>
                          {t(
                            "Register a new password to recover your access to your account"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="Tech4H" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/login">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={mainTheme === "dark" ? logo : darkLogo}
                            alt="Tech4H"
                            className="rounded-circle"
                            height="50"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={handleValidSubmit}
                    >
                      {showAlert && (
                        <Alert color="danger">
                          {renderMessageAlert(textAlert, t, counter)}
                        </Alert>
                      )}
                      {success && message && (
                        <Alert color="success">
                          {message === "If the email is valid, a reset token has been sent" &&
                            t("If the email is valid, a reset token has been sent")}
                        </Alert>
                      )}
                      <div className="form-group">
                        <AvField
                          name="slug"
                          label={t("Slug")}
                          className="form-control"
                          placeholder={t("Enter your slug")}
                          type="slug"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("Required Field"),
                            },
                          }}
                        />
                        <AvField
                          name="email"
                          label={t("Email")}
                          className="form-control"
                          placeholder={t("Enter email")}
                          type="email"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("Required Field"),
                            },
                            email: {
                              value: true,
                              errorMessage: t("Incorrect email"),
                            },
                          }}
                        />
                      </div>
                      <Row className="form-group">
                        <Col className="text-right">
                          {loading ? (
                            <Button
                              disabled={true}
                              style={{
                                width: "100px",
                                cursor: "no-drop",
                              }}
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                            >
                              <Spinner size="sm" animation="border" />
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                              type="submit"
                              id="showtoast"
                              disabled={!isDisabled}
                            >
                              {t("Recover")}
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Go back to")}{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>© {new Date().getFullYear()} Tech4humans.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ForgetPasswordPage);
